(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-anchor-menu"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('maison-anchor-menu')){
  customElements.define('maison-anchor-menu',class extends HTMLElement{
    connectedCallback(){
      this.setup=this.setup.bind(this);
      this.click=this.click.bind(this);
      this.updateEdges=this.updateEdges.bind(this);
      this.nav=this.querySelector('nav');
      this.nav.addEventListener('scroll',this.updateEdges,{passive:true});
      this.resizeObserver=new ResizeObserver(this.updateEdges);
      this.resizeObserver.observe(this.nav);
      this.addEventListener('click',this.click);
      document.addEventListener('shopify:section:load',this.setup);
      if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',this.setup,{once:true});
      else this.setup();
    }
    disconnectedCallback(){
      this.removeEventListener('click',this.click);
      this.nav.removeEventListener('scroll',this.updateEdges);
      this.resizeObserver.disconnect();
      document.removeEventListener('shopify:section:load',this.setup);
      document.removeEventListener('DOMContentLoaded',this.setup);
      this.querySelectorAll('a[data-marker]').forEach(link=>document.getElementById(link.dataset.marker)?.remove());
    }
    setup(){
      this.querySelectorAll('a[data-target]').forEach(link=>{
        const target=document.getElementById(link.dataset.target);
        if(!target){link.hidden=true;return;}
        link.hidden=false;
        target.classList.add('mp-anchor-destination');
        const slug=link.dataset.anchor;
        if(slug){
          let marker=document.getElementById(slug);
          if(!marker){marker=document.createElement('span');marker.id=slug;marker.className='mp-anchor-marker';marker.setAttribute('aria-hidden','true');target.prepend(marker);link.dataset.marker=slug;}
          if(target.contains(marker))link.setAttribute('href','#'+slug);
          else link.setAttribute('href','#'+target.id);
        }
      });
      this.updateEdges();
      if(location.hash){const node=document.getElementById(decodeURIComponent(location.hash.slice(1)));if(node?.classList.contains('mp-anchor-marker'))node.scrollIntoView();}
    }
    updateEdges(){
      const left=this.nav.scrollLeft>2;
      const right=this.nav.scrollWidth-this.nav.clientWidth-this.nav.scrollLeft>2;
      this.toggleAttribute('data-more-left',left);
      this.toggleAttribute('data-more-right',right);
      this.querySelector('.mp-nav-arrow--left').hidden=!left;
      this.querySelector('.mp-nav-arrow--right').hidden=!right;
    }
    click(event){
      const arrow=event.target.closest('[data-direction]');
      if(arrow){this.nav.scrollBy({left:Number(arrow.dataset.direction)*this.nav.clientWidth*.7,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});return;}
      const link=event.target.closest('a[data-target]');
      if(!link||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      const target=document.getElementById(link.dataset.target);
      if(!target)return;
      event.preventDefault();
      history.replaceState(null,'',link.getAttribute('href'));
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
      const heading=target.querySelector('h1,h2,h3');
      if(heading){heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true});}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-avis-demo"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mp-review-demo'))customElements.define('mp-review-demo',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;this.cards=[...this.querySelectorAll('.mpra-card')];this.size=Number(this.dataset.size)||9;this.page=1;this.pages=Math.max(1,Math.ceil(this.cards.length/this.size));this.nav=this.querySelector('nav');this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');this.status=this.querySelector('[role=status]');this.nav.hidden=false;
this.prev.addEventListener('click',()=>this.change(-1));this.next.addEventListener('click',()=>this.change(1));this.draw();
}
change(delta){this.page=Math.max(1,Math.min(this.pages,this.page+delta));this.draw();this.scrollIntoView({behavior:'auto',block:'start'});}
draw(){this.cards.forEach((c,i)=>c.hidden=i<(this.page-1)*this.size||i>=this.page*this.size);this.prev.disabled=this.page===1;this.next.disabled=this.page===this.pages;this.status.textContent=(this.dataset.pageLabel||'[page] / [pages]').replaceAll('[page]',String(this.page)).replaceAll('[pages]',String(this.pages));}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maison-cart')) customElements.define('maison-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', (event) => {
        const step = event.target.closest('[data-step]');
        const remove = event.target.closest('[data-remove]');
        if (!step && !remove) return;
        event.preventDefault();
        if (this.busy) return;
        const item = event.target.closest('[data-key]');
        const input = item.querySelector('[data-quantity]');
        let quantity = 0;
        if (step) {
          quantity = Number(input.value) + Number(step.dataset.step) * Number(input.step || 1);
          if (quantity > 0 && quantity < Number(input.dataset.minimum)) quantity = step.dataset.step === '-1' ? 0 : Number(input.dataset.minimum);
          quantity = Math.max(0, quantity);
          if (input.max) quantity = Math.min(quantity, Number(input.max));
        }
        this.change(item.dataset.key, quantity);
      });
      this.addEventListener('change', (event) => {
        if (this.busy) return;
        if (event.target.matches('[data-quantity]')) {
          const input = event.target;
          const quantity = Number(input.value);
          if (!input.checkValidity() || !Number.isInteger(quantity) || (quantity > 0 && quantity < Number(input.dataset.minimum))) { this.status(this.dataset.error); return; }
          this.change(input.closest('[data-key]').dataset.key, quantity);
        }
        if (event.target.matches('[data-cross-checkbox]') && event.target.checked) {
          this.request('cart/add.js', {items:[{id:Number(event.target.form.elements.id.value),quantity:1}]});
        }
      });
      this.addEventListener('submit', async (event) => {
        if (this.busy) { event.preventDefault(); return; }
        if (event.target.matches('[data-code-form]')) {
          event.preventDefault();
          const code = event.target.elements.discount.value.trim();
          if (!code) return;
          this.request('cart/update.js', {}, code);
        } else if (event.target.matches('[data-cross-form]')) {
          event.preventDefault();
          this.request('cart/add.js',{items:[{id:Number(event.target.elements.id.value),quantity:1}]});
        } else if (event.target.matches('[data-cart-form]') && event.submitter?.name !== 'checkout') {
          event.preventDefault();
        }
      });
    }
    status(message) { const node = this.querySelector('[role="status"]'); node.textContent = message; }
    change(key,quantity) { return this.request('cart/change.js',{id:key,quantity}); }
    async render(sections) {
      const html = sections?.[this.dataset.section];
      const parsed = html && new DOMParser().parseFromString(html,'text/html').querySelector('maison-cart');
      if (!parsed) throw new Error(this.dataset.error);
      this.innerHTML = parsed.innerHTML;
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) bubble.innerHTML = new DOMParser().parseFromString(sections['cart-icon-bubble'],'text/html').querySelector('.shopify-section')?.innerHTML || sections['cart-icon-bubble'];
    }
    async request(endpoint, payload, code) {
      if (this.busy) return;
      this.busy = true;
      this.setAttribute('aria-busy','true');
      this.querySelectorAll('button,input').forEach(el => { el.disabled = true; });
      try {
        if (code) {
          const current = await fetch(this.dataset.root + 'cart.js',{signal:AbortSignal.timeout(15000)});
          if (!current.ok) throw new Error(this.dataset.error);
          const cart = await current.json();
          const codes = (cart.discount_codes || []).filter(c => c.applicable).map(c => c.code);
          payload.discount = [...new Set([...codes,code])].join(',');
        }
        const response = await fetch(this.dataset.root + endpoint,{method:'POST',signal:AbortSignal.timeout(15000),headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({...payload,sections:[this.dataset.section,'cart-icon-bubble'],sections_url:location.pathname + location.search})});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        await this.render(result.sections);
        let message = this.dataset.updated;
        if (code) {
          const submitted = result.discount_codes?.find(c => c.code.toLowerCase() === code.toLowerCase());
          message = submitted && !submitted.applicable ? this.dataset.codeInvalid : this.dataset.codeResult;
        }
        this.status(message);
        this.querySelector('[role="status"]').focus({preventScroll:true});
      } catch (error) {
        try {
          const url = new URL(location.href);
          url.searchParams.set('sections',[this.dataset.section,'cart-icon-bubble'].join(','));
          const response = await fetch(url,{signal:AbortSignal.timeout(15000)});
          if (response.ok) await this.render(await response.json());
        } catch (_) { }
        this.status(error.name === 'TimeoutError' || error.name === 'TypeError' ? this.dataset.error : error.message || this.dataset.error);
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.querySelectorAll('button,input').forEach(el => { el.disabled = false; });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-formats-kit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maison-choice')) {
  customElements.define('maison-choice', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('[data-controls]').hidden = false;
      this.querySelector('[data-variant-id]').disabled = false;
      this.addEventListener('change', () => this.updateChoice());
      this.querySelector('form').addEventListener('submit', event => {
        this.updateChoice();
        if (this.querySelector('[data-submit]').disabled) event.preventDefault();
      });
      this.updateChoice();
    }
    updateChoice() {
      const kind = this.querySelector('.mp-choice__kinds input:checked');
      const isKit = kind && kind.value === 'kit';
      const formats = this.querySelector('[data-formats]');
      formats.hidden = !!isKit;
      formats.disabled = !!isKit;
      this.querySelector('[data-kit-details]').hidden = !isKit;
      this.querySelectorAll('[data-photo]').forEach(photo => {
        photo.hidden = photo.dataset.photo !== (isKit ? 'kit' : 'powder');
      });
      const choice = isKit ? this.querySelector('[data-kit]') : this.querySelector('[data-formats] input:checked');
      const available = !!(kind && !kind.disabled && choice && !choice.disabled);
      const variant = this.querySelector('[data-variant-id]');
      variant.value = available ? (isKit ? choice.dataset.id : choice.value) : '';
      const button = this.querySelector('[data-submit]');
      button.disabled = !available;
      const template = isKit ? this.dataset.kitButton : this.dataset.powderButton;
      this.querySelector('[data-button-label]').textContent = available
        ? template.replaceAll('[format]', choice.dataset.title).replaceAll('[price]', choice.dataset.price)
        : this.dataset.soldOut;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-nutrition-b"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
root.querySelectorAll('.mp-nutrition-b').forEach(section=>{
if(section.dataset.ready)return;section.dataset.ready='1';
const dose=Number(section.dataset.dose)||2,buttons=[...section.querySelectorAll('[data-portion]')];
const format=n=>new Intl.NumberFormat('fr-FR',{maximumFractionDigits:n>0&&n<0.01?3:2}).format(n);
function render(amount){
const factor=amount/100;
section.querySelectorAll('[data-value]').forEach(el=>el.textContent=format(Number(el.dataset.value)*factor)+' '+el.dataset.unit);
section.querySelectorAll('[data-calories]').forEach(el=>el.textContent=format(Number(el.dataset.calories)*factor));
section.querySelectorAll('[data-caption-output]').forEach(el=>el.textContent=(section.dataset.caption||'pour [quantite] g de poudre').replaceAll('[quantite]',format(amount)));
const energy=section.querySelector('[data-energy]');if(energy)energy.textContent=format(Number(energy.dataset.kj)*factor)+' kJ / '+format(Number(energy.dataset.kcal)*factor)+' kcal';
buttons.forEach(b=>{const active=b.dataset.portion==='100'?amount===100:amount===dose;b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',String(active))});
}
buttons.forEach(b=>b.addEventListener('click',()=>render(b.dataset.portion==='100'?100:dose)));render(100);
});
}
init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-nutrition"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mp-nutrition').forEach(section=>{
if(section.dataset.ready)return;section.dataset.ready='1';
const dose=Number(section.dataset.dose)||2;const buttons=[...section.querySelectorAll('[data-portion]')];
const formatted=(n)=>new Intl.NumberFormat('fr-FR',{maximumFractionDigits:2}).format(Number(n.toFixed(2)));
function render(amount){
const factor=amount/100;
section.querySelectorAll('[data-value]').forEach(el=>{const base=Number(el.dataset.value);el.textContent=formatted(base*factor)+' '+el.dataset.unit});
const energy=section.querySelector('[data-energy]');energy.textContent=formatted(Number(energy.dataset.kj)*factor)+' kJ / '+formatted(Number(energy.dataset.kcal)*factor)+' kcal';
buttons.forEach(button=>{const active=(button.dataset.portion==='100'&&amount===100)||(button.dataset.portion==='dose'&&amount===dose);button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active))});
}
buttons.forEach(button=>button.addEventListener('click',()=>render(button.dataset.portion==='100'?100:dose)));
});

  } catch(e) { console.error(e); }
})();
})();
